import { BaseFetch } from "../main-model"
export default class StudentAssessmentModel extends BaseFetch {
    getStudentAssessmentBy = (data) =>
        this.authFetch({
            url: "student_assessment_student/getStudentAssessmentBy",
            method: "POST",
            body: JSON.stringify(data),
        })
        getStudentAssessmentId = (data) =>
        this.authFetch({
            url: "student_assessment_student/getStudentAssessmentId",
            method: "POST",
            body: JSON.stringify(data),
        })
        insertStudentAssessment = (data) =>
        this.authFetch({
            url: "student_assessment_student/insertStudentAssessment",
            method: "POST",
            body: JSON.stringify(data),
        })
        deleteStudentAssessmentId = (data) =>
        this.authFetch({
            url: "student_assessment_student/deleteStudentAssessmentId",
            method: "POST",
            body: JSON.stringify(data),
        })
        getStudentAssessmentStudentBy = (data) =>
        this.authFetch({
            url: "student_assessment_student/getStudentAssessmentStudentBy",
            method: "POST",
            body: JSON.stringify(data),
        })
        updateStudentAssessmentId = (data) =>
        this.authFetch({
            url: "student_assessment_student/updateStudentAssessmentId",
            method: "POST",
            body: JSON.stringify(data),
        })

        
}
